import { API_URL_FACTORY } from '@factories/apiUrlFactory'
import { getUtmLead } from '@components/MainWidget/ChallanWidgetLanding/helper'
import { errorWithStack } from '@utils/logger'

type FetchDeepLinkProps = {
  regNo: string
  widgetType: string
  mobileNo?: string
  selectedProvider?: any
}

export const fetchDeepLink = async ({
  regNo,
  widgetType,
  mobileNo = '',
  selectedProvider,
}: FetchDeepLinkProps): Promise<string> => {
  const utmLead = getUtmLead()
  try {
    const downloadApi = API_URL_FACTORY.DEPP_LINK_API(
      regNo,
      widgetType,
      utmLead,
      mobileNo,
      selectedProvider?.biller_details_id
    )
    const response = await fetch(downloadApi)
    const data = await response.json()
    return data?.data?.url || data?.deepLink || null
  } catch (e) {
    errorWithStack('error fetching deep link', e)
    return ''
  }
}
